import { Autocomplete, TextField } from '@mui/material';
import { cities } from '../../constants/Cities';

type CitiesDropdownProps = {
  label?: string;
  value: string[];
  onChange: (newCities: string[]) => void;
  disabled?: boolean;
};

export const CitiesDropdown = (props: CitiesDropdownProps) => {
  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      limitTags={3}
      size='small'
      disabled={props.disabled}
      fullWidth
      renderInput={(params) => (
        <TextField
          {...params}
          label={props.label}
          variant='outlined'
          fullWidth
        />
      )}
      options={cities}
      onChange={(_, selectedCities) => props.onChange(selectedCities)}
      value={props.value}
    />
  );
};
